import {FavoritePlace, FavoritePlaceParams} from "domain/usecases";
import {HealthGuideFavoritePlaceItem} from "../types";
import {makeGetFavoritePlaces} from "main/factories/usecases";

export async function getFavoritePlaces({signal}: FavoritePlaceParams): Promise<HealthGuideFavoritePlaceItem[]> {
  const favoritePlacesParser = (item: FavoritePlace): HealthGuideFavoritePlaceItem => ({
    id: `${item.nmLocal}-${item.cdBeneficiarioEnderecoFavorito}-${item.nuCep}`,
    address: item,
  });
  const favoritePlaces = await makeGetFavoritePlaces().get({signal});
  if (!Array.isArray(favoritePlaces)) {
    return [];
  }
  return favoritePlaces.map(favoritePlacesParser);
}
